module.exports = __webpack_public_path__ + "static/media/washington-dc-54.2ac72169.jpg";